import { FormGroup, Input, Label } from 'reactstrap'
import PropTypes from 'prop-types'
import { DETAIL_OPTIONS } from 'domains/fast-sell-product/constants'

const propTypes = {
  onClickCheckBox : PropTypes.func,
  details         : PropTypes.arrayOf(
    PropTypes.string
  )
}

const defaultProps = {
  onClickCheckBox: () => { }
}

const FastSellProductDetailCheckboxField = ({
  onClickCheckBox,
  details,
  ...props
}) => {

  const initialCheckBoxValue = (checkBox) => details.find((detail) => detail === checkBox)

  return (
    <div { ...props }>
      {
        DETAIL_OPTIONS.map((checkBox) => (
          <div key={ `checkbox-${checkBox?.value}` }>
            <FormGroup
              check
              inline
            >
              <Input
                type="checkbox"
                defaultChecked={ initialCheckBoxValue(checkBox?.value) }
                onChange={ (event) => onClickCheckBox(checkBox?.value, event) }
              />
              <Label check>{ checkBox?.label }</Label>
            </FormGroup>
          </div>

        ))
      }
    </div>
  )
}

FastSellProductDetailCheckboxField.propTypes    = propTypes
FastSellProductDetailCheckboxField.defaultProps = defaultProps

export default FastSellProductDetailCheckboxField